/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@heroui/dropdown";
import { motion } from "motion/react";

interface ProductCategorySelectorProps {
  parsedAllPromoData: {
    [key: string]: promoListItem[];
  };
  selectedCategory: any;
  setSelectedCategory: any;
}

const ProductCategoryNameParser = (key: string) => {
  if (key === "all") {
    return "All Categories";
  }

  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const ProductCategorySelector: React.FC<ProductCategorySelectorProps> = ({
  parsedAllPromoData,
  selectedCategory,
  setSelectedCategory,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <Dropdown onOpenChange={(isOpen) => setIsDropdownOpen(isOpen)}>
      <DropdownTrigger>
        <div className="flex items-center gap-10 cursor-pointer justify-between max-w-[350px] w-full border-[1px] border-[#939393]/80 rounded-full px-6 py-3">
          <p>
            {selectedCategory?.currentKey === "all" || !selectedCategory
              ? "Select Product Categories"
              : ProductCategoryNameParser(selectedCategory.currentKey)}
          </p>
          <motion.img
            alt="Down Arrow"
            animate={{ rotate: isDropdownOpen ? 180 : 0 }}
            className="w-4 h-4 object-contain"
            exit={{ rotate: 0 }}
            initial={{ rotate: 0 }}
            src="/icons/arrow_down_red_no_trail.svg"
            transition={{ duration: 0.2 }}
          />
        </div>
      </DropdownTrigger>
      <DropdownMenu
        defaultSelectedKeys={["all"]}
        selectedKeys={selectedCategory}
        selectionMode="single"
        onSelectionChange={setSelectedCategory}
      >
        {Object.keys(parsedAllPromoData).map((category: string) => (
          <DropdownItem key={category}>
            {ProductCategoryNameParser(category)}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProductCategorySelector;
